import { Subject } from 'rxjs';
import type { Wizard } from '../wizard';
import { WizardStepTree } from './wizard-step';
import { WizardStepTracker } from './wizard-step-tracker';

export class WizardStepController {
  complete = new Subject<void>();

  back = new Subject<void>();

  title = new Subject<string>();

  skip = new Subject<void>();

  dirty = new Subject<void>();

  closeWizard = new Subject<void>();

  unsavedData: object = {};

  constructor(
    private _wizard: Wizard,
    public params: object,
    public data: Record<string, string | number | boolean | object>,
    public trackedValue: object,
    public isFinal = false,
    public isFirst = true
  ) {}

  markAsComplete() {
    this.complete.next();
  }

  skipStep() {
    this.skip.next();
  }

  goBack() {
    this.back.next();
  }

  setTitle(value: string) {
    this.title.next(value);
  }

  setDirty() {
    this.dirty.next();
  }

  saveGlobalData(key: string | number, value: string | number | boolean | object) {
    this._wizard.stepTracker.saveData(key, value);
  }

  updateWizardStepGroups(stepGroups: WizardStepTree) {
    this._wizard.stepTracker.updateWizardStepTree(stepGroups);
  }

  updateWizardStepFooterProps(props: object) {
    this._wizard.stepTracker.updateWizardStepFooterProps(props);
  }

  getStepTracker(): WizardStepTracker {
    return this._wizard.stepTracker;
  }

  setCloseWizard() {
    this.closeWizard.next();
  }

  getWizardController() {
    return this._wizard.getController();
  }
}
